'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Dom = require('../utils/Dom');

var _underscore = require('../utils/underscore');

var _passthroughProps = require('../utils/propTypes/passthroughProps');

var _passthroughProps2 = _interopRequireDefault(_passthroughProps);

var _Controllable = require('../decorators/Controllable');

var _Controllable2 = _interopRequireDefault(_Controllable);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Functions = require('../core/Functions');

var _ReactNodes = require('../core/ReactNodes');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _decorators = require('../utils/propTypes/decorators');

var _UIAbstractDropdown = require('./abstract/UIAbstractDropdown');

var _UIAbstractDropdown2 = _interopRequireDefault(_UIAbstractDropdown);

var _UIAbstractDropdownWithSearchbox = require('./abstract/UIAbstractDropdownWithSearchbox');

var _UIAbstractDropdownWithSearchbox2 = _interopRequireDefault(_UIAbstractDropdownWithSearchbox);

var _UIPopover = require('../tooltip/UIPopover');

var _UIPopover2 = _interopRequireDefault(_UIPopover);

var _PlacementConstants = require('../tooltip/PlacementConstants');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var USE_CLASSES = {
  list: 'private-dropdown--list',
  unstyled: ''
};

var UIDropdown = function (_PureComponent) {
  _inherits(UIDropdown, _PureComponent);

  function UIDropdown(props) {
    _classCallCheck(this, UIDropdown);

    var _this = _possibleConstructorReturn(this, (UIDropdown.__proto__ || Object.getPrototypeOf(UIDropdown)).call(this, props));

    _this.menuRefCallback = function (ref) {
      _this._menuEl = ref;
      if (ref) _this.checkForSearchbox();
    };

    _this.handleOpenComplete = function () {
      var _this$props = _this.props,
          onOpenComplete = _this$props.onOpenComplete,
          use = _this$props.use;


      if (!(_this.state.hasSearchbox || use === 'unstyled')) {
        // Move the focus to the first menu item (<li>).
        _this.focusNextMenuItem();
      }

      if (onOpenComplete) onOpenComplete();
    };

    _this.handleMenuClick = function (evt) {
      var _this$props2 = _this.props,
          closeOnMenuClick = _this$props2.closeOnMenuClick,
          onOpenChange = _this$props2.onOpenChange;

      if (closeOnMenuClick) {
        var target = evt.target;


        var iterableTarget = target;

        if (!(0, _Dom.closest)(target, '[data-dropdown-menu]')) return; // Portals! #6595

        while (iterableTarget && !(0, _Dom.elementHasClass)(iterableTarget, 'private-dropdown') && iterableTarget.getAttribute('data-component-name') !== 'UIFileButton') {
          // Only close when clicking a `button` or `a` tag!
          if (['BUTTON', 'A'].includes(iterableTarget.nodeName) && !iterableTarget.disabled) {
            onOpenChange((0, _SyntheticEvent2.default)(false));
            return;
          }

          iterableTarget = iterableTarget.parentElement;
        }
      }
    };

    _this.handleSearchChange = function () {
      _this.forceUpdate(); // Reposition the Tether after the search results flush to the DOM
    };

    _this.handleKeyDown = function (evt) {
      var key = evt.key;
      var _this$props3 = _this.props,
          onOpenChange = _this$props3.onOpenChange,
          open = _this$props3.open,
          use = _this$props3.use;

      if (!open) return;

      if (_this.state.hasSearchbox) {
        if (key === 'Enter') {
          onOpenChange((0, _SyntheticEvent2.default)(false));
        }
        evt.stopPropagation();
        return;
      }

      // Move the focus to the next/prev menu item (<li>).
      if (use !== 'unstyled' && (key === 'ArrowDown' || key === 'ArrowUp')) {
        if (_this.focusNextMenuItem(key === 'ArrowUp')) {
          evt.preventDefault();
        }
        evt.stopPropagation();
      }
    };

    _this.renderContent = function () {
      var _this$props4 = _this.props,
          children = _this$props4.children,
          Content = _this$props4.Content;
      var hasSearchbox = _this.state.hasSearchbox;

      var mutatedChildren = children;
      if (hasSearchbox && !Content) {
        mutatedChildren = _react.Children.map(children, function (child) {
          if ((0, _ReactNodes.nodeDisplayNameMatches)(child, /UITypeahead|UIGroupedTypeahead/)) {
            return _react2.default.cloneElement(child, {
              autoFocus: _this._enableAutofocus ? true : child.props.autoFocus,
              onSearchChange: (0, _Functions.memoizedSequence)(child.props.onSearchChange, _this.handleSearchChange)
            });
          }
          return child;
        });
      }

      return _react2.default.createElement(
        'div',
        {
          'data-dropdown-menu': true,
          id: _this._id,
          onClick: _this.handleMenuClick,
          ref: _this.menuRefCallback,
          role: 'presentation'
        },
        Content ? _react2.default.createElement(Content, null) : mutatedChildren
      );
    };

    _this.state = {
      hasSearchbox: false
    };
    _this._id = 'dropdown-menu-' + (0, _underscore.uniqueId)();
    _this.popoverRef = _react2.default.createRef();
    return _this;
  }

  _createClass(UIDropdown, [{
    key: 'UNSAFE_componentWillReceiveProps',
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // Only autofocus when `open` prop goes from false => true
      if (!this.props.open && nextProps.open) {
        this._enableAutofocus = true;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.checkForSearchbox();

      // Reposition the Tether, as the results list may have changed height.
      if (this.popoverRef.current) this.popoverRef.current.reposition();
    }
  }, {
    key: 'checkForSearchbox',
    value: function checkForSearchbox() {
      // Check if we have a searchbox, as we may need to make the arrow color match.
      if (this._menuEl && document.body.contains(this._menuEl)) {
        var hasSearchbox = !!this._menuEl.querySelector('.private-typeahead:not(.hide-search)');
        if (this.state.hasSearchbox !== hasSearchbox) {
          this.setState({ hasSearchbox: hasSearchbox });
        }
      }
    }
  }, {
    key: 'focusNextMenuItem',
    value: function focusNextMenuItem() {
      var reverse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var menu = document.getElementById(this._id);
      return (0, _Dom.moveFocusToNext)('li', menu, reverse);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoPlacement = _props.autoPlacement,
          buttonClassName = _props.buttonClassName,
          buttonText = _props.buttonText,
          buttonUse = _props.buttonUse,
          children = _props.children,
          className = _props.className,
          __closeOnMenuClick = _props.closeOnMenuClick,
          __Content = _props.Content,
          dropdownClassName = _props.dropdownClassName,
          locked = _props.locked,
          iconName = _props.iconName,
          popoverProps = _props.popoverProps,
          popoverRef = _props.popoverRef,
          use = _props.use,
          rest = _objectWithoutProperties(_props, ['autoPlacement', 'buttonClassName', 'buttonText', 'buttonUse', 'children', 'className', 'closeOnMenuClick', 'Content', 'dropdownClassName', 'locked', 'iconName', 'popoverProps', 'popoverRef', 'use']);

      var containsFooter = _react.Children.toArray(children).some(function (child) {
        return (0, _ReactNodes.nodeDisplayNameMatches)(child, /UIDropdownFooter/);
      });

      var computedDropdownClassName = (0, _classnames2.default)(className, dropdownClassName, USE_CLASSES[use], {
        'p-y-0': containsFooter
      });

      var defaultIcon = buttonText ? undefined : 'settings';

      return _react2.default.createElement(
        _UIAbstractDropdownWithSearchbox2.default,
        _extends({}, rest, {
          autoPlacement: autoPlacement,
          buttonText: buttonText,
          buttonUse: buttonUse,
          className: buttonClassName,
          Content: this.renderContent,
          dropdownClassName: computedDropdownClassName,
          hasSearchbox: this.state.hasSearchbox,
          iconName: iconName !== undefined ? iconName : defaultIcon,
          locked: locked,
          onOpenComplete: this.handleOpenComplete,
          onKeyDown: this.handleKeyDown,
          popoverRef: popoverRef || this.popoverRef,
          popoverProps: popoverProps
        }),
        children
      );
    }
  }]);

  return UIDropdown;
}(_react.PureComponent);

UIDropdown.propTypes = _extends({}, _UIAbstractDropdown2.default.propTypes, {
  arrowColor: (0, _decorators.hidden)(_UIAbstractDropdown2.default.propTypes.arrowColor),
  buttonClassName: _propTypes2.default.string,
  buttonText: _UIAbstractDropdown2.default.propTypes.buttonText,
  children: _UIAbstractDropdown2.default.propTypes.children,
  closeOnMenuClick: _propTypes2.default.bool.isRequired,
  iconName: _UIAbstractDropdown2.default.propTypes.iconName,
  locked: _UIAbstractDropdown2.default.propTypes.locked,
  onOpenChange: _UIAbstractDropdown2.default.propTypes.onOpenChange,
  open: _UIAbstractDropdown2.default.propTypes.open,
  placement: _propTypes2.default.oneOf(_PlacementConstants.PLACEMENTS),
  popoverProps: (0, _passthroughProps2.default)(_UIPopover2.default),
  popoverRef: _refObject2.default,
  use: _propTypes2.default.oneOf(Object.keys(USE_CLASSES)).isRequired
});

UIDropdown.defaultProps = _extends({}, _UIAbstractDropdown2.default.defaultProps, {
  buttonUse: 'tertiary-light',
  closeOnMenuClick: true,
  menuWidth: 'auto',
  pinToConstraint: true,
  use: 'list'
});

UIDropdown.displayName = 'UIDropdown';

exports.default = (0, _Controllable2.default)(UIDropdown, ['open']);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/dropdown/UIDropdown.js
// module id = 535
// module chunks = 177